export const baseURL = {
  imgUrl: "https://aecgk.com",
  downloadUrl: "https://www.huzwyw.top/",
  apiHost: "https://api.yyds1.link/",
  //   apiHost: 'https://api.xvideos.pusta.click/',
};
